import React from "react";
import "./Header.css";

const Header = () => {
  return (
    <div className="bg-info bg-gradient text-white py-5 d-flex justify-content-center align-items-center">
      <div className="py-3">
        <h1 className="header-title">Quiz with Fun</h1>
        <p className="border py-2 rounded d-flex fw-bold justify-content-center text-secondary">
          Play and Develop your skill
        </p>
      </div>
    </div>
  );
};

export default Header;
